import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ConfigModule, ProcessModule, StateConfig, StateTransferType } from '@spartacus/core';
import { MyShopPersistenceService } from './my-shop-persistence.service';
import { MYSHOP_FEATURE } from './my-shop-state';
import { reducerProvider, reducerToken } from './reducers';

function catalogStoreConfigFactory(): StateConfig {
  // if we want to reuse CATALOG_FEATURE const in config, we have to use factory instead of plain object
  return {
    state: {
      ssrTransfer: {
        keys: {
          [MYSHOP_FEATURE]: StateTransferType.TRANSFER_STATE,
        },
      },
    },
  };
}

export function myShopStatePersistenceFactory(myShopPersistenceService: MyShopPersistenceService): () => void {
  return () => myShopPersistenceService.sync();
}

@NgModule({
  imports: [
    ProcessModule.forRoot(),
    StoreModule.forFeature(MYSHOP_FEATURE, reducerToken),
    ConfigModule.withConfigFactory(catalogStoreConfigFactory),
  ],
  providers: [
    reducerProvider,
    provideAppInitializer(() => {
      const initializerFn = myShopStatePersistenceFactory(inject(MyShopPersistenceService));

      return initializerFn();
    }),
  ],
})
export class MyShopStoreModule {}
